// https://prazdevs.github.io/pinia-plugin-persistedstate/frameworks/nuxt-3.html
import { defineStore } from 'pinia'

export const useConsentStore = defineStore(
  'consent',
  () => {
    interface CookiePreferences {
      [key: string]: boolean
      analytics: boolean
      advertising: boolean
      functionality: boolean
    }

    const { defaultConsent } = getData().data

    const show_cookie_banner = ref<boolean>(false)
    const consent = ref<boolean>(defaultConsent || false)
    const preferences = ref<CookiePreferences>({
      essential: true, // Does nothing, but needed because of a loop
      analytics: true,
      advertising: true,
      functionality: true,
    })

    const enableAnalytics = computed(() => consent.value && preferences.value.analytics)
    const enableAdvertising = computed(() => consent.value && preferences.value.advertising)

    function show() {
      show_cookie_banner.value = true
    }

    function allow(allow_all: boolean) {
      consent.value = true
      show_cookie_banner.value = false
      if (allow_all) {
        Object.keys(preferences.value).forEach((key) => {
          preferences.value[key] = true
        })
      }
      console.log('User consents to cookies/ tracking.')
    }

    function disallow(disallow_all: boolean) {
      consent.value = false
      show_cookie_banner.value = false
      // Object.keys(preferences.value).forEach((key) => {
      //   console.log(key)
      //   if (key !== 'essential') {
      //     preferences.value[key] = false
      //   }
      // })
      if (disallow_all) {
        preferences.value.analytics = false
        preferences.value.advertising = false
        preferences.value.functionality = false
      }
      console.log('User does not consent to cookies/ tracking.')
    }

    return {
      // Refs?
      consent,
      preferences,
      show_cookie_banner,

      // Getters
      enableAnalytics,
      enableAdvertising,

      // Mutations
      show,
      allow,
      disallow,
    }
  },
  { persist: true },
)
